import { Avatar, type AvatarProps, Icon } from "@mui/material";

import getUserInitials from "~/helpers/userInitials";

interface UserAvatarProps {
	imageUrl?: null | string;
	name?: null | string;
	size?: number;
	sx?: AvatarProps["sx"];
}

const UserAvatar = ({ imageUrl, name, size = 30, sx }: UserAvatarProps) => {
	const initials = getUserInitials(name);
	return (
		<Avatar
			alt={name ?? undefined}
			src={imageUrl ?? undefined}
			sx={{ bgcolor: "grey.600", fontSize: size * 0.42, height: size, width: size, ...sx }}
		>
			{initials || <Icon sx={{ fontSize: size * 0.66 }}>person</Icon>}
		</Avatar>
	);
};

export default UserAvatar;
